(() => {
  if (customElements.get('delain-hero-schedule')) return;

  function taipeiTime(value) {
    const match = /^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2})$/.exec((value || '').trim());
    if (!match) return NaN;
    const [, year, month, day, hour, minute] = match.map(Number);
    if (year < 2000 || month < 1 || month > 12 || day < 1 || hour > 23 || minute > 59) return NaN;
    const local = new Date(Date.UTC(year, month - 1, day, hour, minute));
    if (local.getUTCFullYear() !== year || local.getUTCMonth() !== month - 1 || local.getUTCDate() !== day) return NaN;
    return local.getTime() - 8 * 60 * 60 * 1000;
  }

  class DelainHeroSchedule extends HTMLElement {
    connectedCallback() {
      queueMicrotask(() => {
        if (this.isConnected) this.initialize();
      });
    }

    initialize() {
      this.abort?.abort();
      clearTimeout(this.timer);
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.defaultMedia = this.querySelector('[data-schedule-default]');
      this.output = this.querySelector('[data-schedule-output]');
      this.link = this.querySelector('[data-schedule-link]');
      this.status = this.querySelector('[data-schedule-status]');
      this.captionDefault = this.querySelector('[data-caption-default]');
      this.captionOutput = this.querySelector('[data-caption-output]');
      if (!this.defaultMedia || !this.output || !this.link) return;
      this.entries = Array.from(this.querySelectorAll('template[data-schedule-banner]'), (template, index) => {
        const start = taipeiTime(template.dataset.start);
        const end = template.dataset.end.trim() ? taipeiTime(template.dataset.end) : Infinity;
        return {
          template, index, id: template.dataset.blockId, start, end,
          valid: Number.isFinite(start) && end > start && !!template.content.querySelector('img'),
          enabled: template.dataset.enabled === 'true'
        };
      });
      this.activeId = undefined;
      this.previewId = null;
      this.enabled = this.dataset.enabled === 'true';
      document.addEventListener('visibilitychange', () => this.refresh(), options);
      window.addEventListener('pageshow', () => this.refresh(), options);
      if (window.Shopify?.designMode) {
        document.addEventListener('shopify:block:select', event => {
          if (!this.entries.some(entry => entry.id === event.detail.blockId)) return;
          this.previewId = event.detail.blockId;
          this.refresh();
        }, options);
        document.addEventListener('shopify:block:deselect', event => {
          if (event.detail.blockId !== this.previewId) return;
          this.previewId = null;
          this.refresh();
        }, options);
      }
      this.refresh();
    }

    disconnectedCallback() {
      clearTimeout(this.timer);
      this.abort?.abort();
    }

    refresh() {
      clearTimeout(this.timer);
      const now = Date.now();
      const available = this.entries.filter(entry => entry.enabled && entry.valid);
      let selected = null;
      if (this.enabled) {
        for (const entry of available) {
          if (entry.start <= now && now < entry.end && (!selected || entry.start >= selected.start)) selected = entry;
        }
      }
      const preview = this.previewId && this.entries.find(entry => entry.id === this.previewId);
      if (preview?.template.content.querySelector('img')) selected = preview;
      const nextId = selected?.id || '';
      if (this.activeId !== nextId) {
        if (selected) {
          this.output.replaceChildren(selected.template.content.cloneNode(true));
          this.output.hidden = false;
          this.defaultMedia.hidden = true;
          this.defaultMedia.querySelectorAll('video').forEach(video => video.pause());
        } else {
          this.output.replaceChildren();
          this.output.hidden = true;
          this.defaultMedia.hidden = false;
          if (this.activeId) this.defaultMedia.querySelectorAll('video[autoplay]').forEach(video => video.play().catch(() => {}));
        }
        const url = selected ? selected.template.dataset.link : this.dataset.defaultLink;
        const label = selected ? selected.template.dataset.label : this.dataset.defaultLabel;
        if (url) {
          this.link.setAttribute('href', url);
          this.link.hidden = false;
        } else {
          this.link.removeAttribute('href');
          this.link.hidden = true;
        }
        this.link.setAttribute('aria-label', label || this.dataset.defaultLabel);
        if (this.captionDefault && this.captionOutput) {
          const ownCaption = selected && selected.template.dataset.inheritCaption === 'false';
          const captionTemplate = ownCaption && selected.template.content.querySelector('template[data-schedule-caption]');
          this.captionOutput.replaceChildren();
          if (captionTemplate) this.captionOutput.append(captionTemplate.content.cloneNode(true));
          this.captionDefault.hidden = Boolean(ownCaption);
          this.captionOutput.hidden = !ownCaption;
        }
        this.activeId = nextId;
      }
      if (this.status) {
        const invalid = this.entries.filter(entry => entry.enabled && !entry.valid).length;
        this.status.textContent = preview
          ? '排程 Banner 預覽（僅編輯器）：' + (preview.template.dataset.title || '未命名') + (preview.valid ? '' : '；請檢查時間或必填圖片')
          : !this.enabled ? 'Banner 排程已停用，顯示預設圖片。'
          : invalid ? invalid + ' 筆啟用的排程無效，請檢查圖片及時間格式（YYYY-MM-DD HH:mm）。' : '';
        this.status.hidden = !this.status.textContent;
      }
      let delay = 30000;
      if (this.enabled) for (const entry of available) {
        for (const boundary of [entry.start, entry.end]) {
          if (boundary > now) delay = Math.min(delay, boundary - now);
        }
      }
      this.timer = setTimeout(() => this.refresh(), Math.max(1, delay));
    }
  }

  customElements.define('delain-hero-schedule', DelainHeroSchedule);
})();

